module.exports = __webpack_public_path__ + "img/深圳麦士德福.b2da5d11.jpg";